/**
 * Builds an axios request config carrying an explicit Bearer Authorization header.
 *
 * LESSEEPORT-1594: in the MOP one-time-link flow the shared api client's
 * interceptor loses the Authorization header at runtime, so payment write
 * calls pass it explicitly (same mechanism PaymentApplication uses for its
 * own calls). With no token this returns an empty config, leaving regular
 * logged-in portal behavior untouched.
 *
 * @param {string|null|undefined} token - JWT to send, e.g. the one-time-link key
 * @returns {object} axios config with the Authorization header, or {}
 */
export const authHeaderConfig = (token) =>
  token ? { headers: { Authorization: `Bearer ${token}` } } : {};
